import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "custom-pc" }
const _hoisted_2 = { class: "custom-pc__layout" }
const _hoisted_3 = { class: "custom-pc__layout__title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "custom-pc__layout__title-text" }, " 页头高度 ", -1)
const _hoisted_5 = { class: "custom-pc__layout__title__r" }
const _hoisted_6 = { class: "custom-pc__layout__showNav" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "custom-pc__layout__showNav__text" }, "显示导航栏", -1)
const _hoisted_8 = { class: "custom-pc__layout__showNav__text__r" }
const _hoisted_9 = {
  key: 0,
  class: "custom-pc__layout__title custom-pc__layout__title-nav"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "custom-pc__layout__title-text" }, "导航栏位置", -1)
const _hoisted_11 = { class: "custom-pc__layout__title__r" }
const _hoisted_12 = {
  key: 1,
  class: "custom-pc__layout__title"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "custom-pc__layout__title-text" }, "导航标签", -1)
const _hoisted_14 = { class: "custom-pc__layout__title__r" }

import { onMounted, ref } from 'vue'
import {
  NTabs,
  NTabPane,
  NSwitch,
  NCollapse,
  NCollapseItem,
  NScrollbar
} from 'naive-ui'
import Icon from '@teams/common/components/icon'
import customHide from './customComponents/customHide.vue'
import PopoverSelect from './customComponents/popoverSelect.vue'
import NewTheme from './customComponents/newTheme.vue'
import ThemeCase from './customComponents/themeCase.vue'
import RadioGroup from './customComponents/radioGroup.vue'
import { useCustomePanal } from './useCustomePanal'
import usePreference from '@teams/common/hooks/usePreference'
import { useEditor } from '@/components/backgroundEditor/hooks'
import { useGroupStore } from '@/store/group'
import {
  pcCustompageHeadList,
  pcCustomNavPositionList,
  pcCustomNavLayoutList
} from './useData'
import { FileInfo } from 'naive-ui/es/upload/src/interface'
import useViewConfig from '@/hooks/useViewConfig'

export interface ICaseItem {
  key: string
  img?: string
  name: string
  official?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'pcCustom',
  setup(__props) {

const {
  PCCustomPanalProps,
  PCCustomThemeProps,
  handleRefreshCustomTheme,
  handleSaveCustomTheme,
  handleLayoutChange,
  handleThemeColorChange
} = useCustomePanal('pc')
const viewConfig = useViewConfig()
const { current, themeList } = usePreference()
const defaultShow = ref('layout')
const switchActive = ref(PCCustomPanalProps.value.showNavBar)
const isCreateNewTheme = ref(false)

const groupStore = useGroupStore()

const groupId = ref(groupStore.groupId)
const currentItem = ref<ICaseItem>({
  key: '',
  name: ''
})
const editor = useEditor({
  groupId: groupId.value
})

const handleShowNavSwitchChange = (value: boolean) => {
  handleLayoutChange('showNavBar', value.toString())
}

const updateIsCreateNewTheme = (val: boolean) => {
  isCreateNewTheme.value = val
}

// 新建模板
const handleCreateNewTheme = () => {
  updateIsCreateNewTheme(true)
}
const emitBack = () => {
  updateIsCreateNewTheme(false)
  defaultShow.value = 'theme'
}

const handleShowSelector = () => {
  editor.updateShowOrCloseSelector()
}

const handleChangeUpload = (options: { file: FileInfo }) => {
  viewConfig.setCustomPanel(false)
  viewConfig.setFloatBall(true)
  editor.handleChange(options)
}

const handleVectorImgSelect = (url: string) => {
  editor.cropperSrc = url
  editor.updateShowEditor(true)
}
// 更改当前主题
const updateCurrentTheme = (item: ICaseItem) => {
  currentItem.value = item
}

onMounted(() => {
  themeList.forEach(item => {
    if (item.key === current.theme.key) {
      currentItem.value = item
    }
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NScrollbar), { style: {"{\n        max-height":"100%"} }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!isCreateNewTheme.value)
          ? (_openBlock(), _createBlock(_unref(NTabs), {
              key: 0,
              "default-value": defaultShow.value,
              animated: "",
              class: "tab",
              "justify-content": "space-evenly"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NTabPane), {
                  name: "layout",
                  tab: "布局",
                  "display-directive": "show"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_unref(NCollapse), {
                        "default-expanded-names": ['pageHead', 'navOps'],
                        "display-directive": "show"
                      }, {
                        arrow: _withCtx(() => [
                          _createVNode(_unref(Icon), { name: "collapseArrow" })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(NCollapseItem), {
                            title: "页头",
                            name: "pageHead"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, [
                                _hoisted_4,
                                _createElementVNode("span", _hoisted_5, [
                                  _createVNode(RadioGroup, {
                                    customList: _unref(pcCustompageHeadList),
                                    "init-key": 
                        _unref(PCCustomPanalProps).isEase ? 'loose' : 'compact'
                      
                                  }, null, 8, ["customList", "init-key"])
                                ])
                              ]),
                              _createVNode(customHide, {
                                "member-avatar-checked": _unref(PCCustomPanalProps).showTeamAvatar,
                                "message-notification-checked": _unref(PCCustomPanalProps).showMessage,
                                "team-memory-checked": _unref(PCCustomPanalProps).showTeamMemory,
                                "sharing-team-checked": _unref(PCCustomPanalProps).showTeamShare,
                                onTeamMemoryCheckedChange: _cache[0] || (_cache[0] = (v) => _unref(handleLayoutChange)('hiddenTeamSpace',(!v).toString())),
                                onMemberAvatarCheckedChange: _cache[1] || (_cache[1] = (v) => _unref(handleLayoutChange)('hiddenTeamMember',(!v).toString())),
                                onMessageNotificationCheckedChange: _cache[2] || (_cache[2] = (v) => _unref(handleLayoutChange)('hiddenMessageAlert',(!v).toString())),
                                onSharingTeamCheckedChange: _cache[3] || (_cache[3] = (v) => _unref(handleLayoutChange)('hiddenShareBtn',(!v).toString()))
                              }, null, 8, ["member-avatar-checked", "message-notification-checked", "team-memory-checked", "sharing-team-checked"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(NCollapseItem), {
                            title: "导航栏",
                            name: "navOps"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_6, [
                                _hoisted_7,
                                _createElementVNode("span", _hoisted_8, [
                                  _createVNode(_unref(NSwitch), {
                                    size: "small",
                                    value: switchActive.value,
                                    "onUpdate:value": [
                                      _cache[4] || (_cache[4] = ($event: any) => ((switchActive).value = $event)),
                                      handleShowNavSwitchChange
                                    ]
                                  }, null, 8, ["value"])
                                ])
                              ]),
                              (switchActive.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _hoisted_10,
                                    _createElementVNode("span", _hoisted_11, [
                                      _createVNode(PopoverSelect, {
                                        customList: _unref(pcCustomNavPositionList),
                                        "init-key": _unref(PCCustomPanalProps).navBarPosition
                                      }, null, 8, ["customList", "init-key"])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (switchActive.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _hoisted_13,
                                    _createElementVNode("span", _hoisted_14, [
                                      _createVNode(RadioGroup, {
                                        customList: _unref(pcCustomNavLayoutList),
                                        "init-key": _unref(PCCustomPanalProps).navBarContentLayout
                                      }, null, 8, ["customList", "init-key"])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(NTabPane), {
                  name: "theme",
                  tab: "主题",
                  "display-directive": "show"
                }, {
                  default: _withCtx(() => [
                    _createVNode(ThemeCase, {
                      onHandleCreateNewTheme: handleCreateNewTheme,
                      onUpdateCurrentTheme: updateCurrentTheme
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["default-value"]))
          : (_openBlock(), _createBlock(NewTheme, {
              key: 1,
              onBack: emitBack,
              onOnThemePanelChange: _unref(handleThemeColorChange),
              onOnRefresh: _unref(handleRefreshCustomTheme),
              onOnSave: _unref(handleSaveCustomTheme),
              onOnVectorImgSelect: handleVectorImgSelect,
              onOnShowSelector: handleShowSelector,
              onOnChangeUpload: handleChangeUpload,
              "custom-theme-props": _unref(PCCustomThemeProps),
              isPcCustom: true,
              currentItem: currentItem.value,
              showNavSwitch: _unref(PCCustomPanalProps).showNavBar
            }, null, 8, ["onOnThemePanelChange", "onOnRefresh", "onOnSave", "custom-theme-props", "currentItem", "showNavSwitch"]))
      ])
    ]),
    _: 1
  }))
}
}

})